export default {
  header: '資料庫',
  general: {
    fromDate: '日期由',
    endDate: '日期至',
    agentName: '顧問名稱',
    customerName: '客戶名稱',
    gender: '性別',
    dob: '出生日期',
    agent: '顧問',
    agentCode: '顧問編號',
    customer: '客戶',
    policyType: '保單類別',
    lifePolicy: '人壽保單',
    giPolicy: '一般保單',
    export: '匯出',
    status: '狀況',
  },
  report: {
    header: '報告',
    customer: {
      customerCode: '客戶編號',
      header: "客戶",
      generalPolicyCount: '一般保險單數量',
      giPremium: '一般保險保費',
      lifePolicyCount: '人壽保險單數',
      lifePremium: '人壽保費',
    },
    performance: {
      header: '表現',
      agentCode: '顧問編號',
      teamCode: '團隊編號',
      premium: '保額',
      commission: '佣金',
      cases: '單量',
      afyp: '年度化首年保費',
      fyc: '首年佣金',
      ifyp: '初始繳付首年保費'
    },
    sale: {
      premium: '保費',
      totalPremiums: '總保費',
      header: '銷售',
      policyNumber: '保單號碼',
      productName: '產品名稱',
      policyOwner: '保單持有人',
      policyType: '保單類別',
      premiumType: '保費類別',
      provider: '保險公司',
      fyp: '首年保費',
      fyc: '首年佣金',
    },
    commission: {
      header: '佣金',
      policyType: '保單類別',
      productCode: '產品編號',
      commissionAcutalReceived: '實收佣金'
    }
  },


}


// WEBPACK FOOTER //
// ./src/Dw/langs/zh_hk/index.js